import { useCallback, useMemo } from "react";

import { ListInfo, ListRowInfo, useListInfo } from "./ListInfoProvider";

export const DEFAULT_ITEM_INFO: ListRowInfo = {
	visible: false,
	enabled: false,
	selected: false
};

export type ListItemInfo = {
	visible: boolean;
	enabled: boolean;
	selected: boolean;

	select(selected: boolean): void;
};

export default function useListItemInfo(id: string): ListItemInfo {
	const info: ListInfo = useListInfo();

	const state: ListRowInfo = useMemo(
		() => info.elements[id] ?? DEFAULT_ITEM_INFO,
		[id, info.elements[id]]
	);

	const onSelect = useCallback(
		(selected: boolean): void => {
			info.setSelected([id], selected);
		},
		[id, info.setSelected]
	);

	const object: ListItemInfo = useMemo(
		() => ({
			...state,
			select: onSelect
		}),
		[state, onSelect]
	);

	return object;
}
